<script>
    import { apiURL } from '../../store.js'
    export let update
    export let color
</script>

<div class="labUpdate">
    <div class="header">
        <div class="date">
            {update.date} —
        </div>
        <div class="title">
            {update.announcement_type}
        </div>
    </div>
    <div class="content">
        {@html update.text}
        {#if update.content.length != 0}
            {#if update.content[0].type == 'link'}
                <a
                    target="_blank"
                    href={update.content[0].value}
                    style="border-bottom: 2px solid {color}"
                >
                    link
                </a>
            {:else}
                <a
                    target="_blank"
                    href="{apiURL}{update.content[0].value.url}"
                    style="border-bottom: 2px solid {color}"
                >
                    {update.content[0].type}
                </a>
            {/if}
        {/if}
    </div>
</div>

<style lang="scss">
    @import "../../styles/vars";

    .date {
        display: inline-block;
        font-family: "Work Sans";
        font-weight: 400;
        font-size: 0.85rem;
    }

    .title {
        display: inline-block;
        font-family: "Work Sans";
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05rem;
        font-size: 0.85rem;
    }

    .labUpdate {
        margin-bottom: 2rem;
    }

    .content {
        a {
            font-family: "Ysabeau";
            font-style: italic;
            color: black;
            text-decoration: none;
            font-size: 1.3rem;
            display: inline;

            &:hover {
                text-decoration: none;
            }
        }
    }

    .labUpdate .content :global(p) {
        font-family: "Ysabeau";
        font-size: 1.25rem;
        margin: 0;
        display: inline;
    }

    @include respond-to(phone) {
        .labUpdate .content :global(p) {
            font-family: "Ysabeau";
            font-size: 1.08rem;
            line-height: 1.45rem;
            margin: 0 0 1rem 0;
        }

        .content {
            a {
                font-size: 1.1rem;
            }
        }
    }
</style>
